import React, { useState } from 'react'
import RateReviewIcon from '@mui/icons-material/RateReview'
import moment from 'moment'
import { Button, Edit, FormWithRedirect, required, SaveButton, SelectInput, TextInput, useNotify, useUpdate } from 'react-admin'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import StyledInput from '../StyledInput'
import CancelIcon from '@mui/icons-material/Cancel'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

export const outcomeChoices = [
  { id: 'Ok', name: 'Ok' },
  { id: 'Ko', name: 'Ko' },
  { id: 'Unknown', name: 'Unknown' },
]

const VisitFeedbackButton = (props) => {
  const { record } = props
  const [openDialog, setOpenDialog] = useState(false)
  const endDate = moment(record.start_date_time).add(record.duration_in_min, 'minutes')
  const feedbackButtonDisabled = moment().isBefore(endDate) || record.outcome != null
  const [update, { loading }] = useUpdate()
  const [confirmed, setConfirmed] = useState(false)
  const notify = useNotify()

  const handleOnclick = () => {
    setOpenDialog(true)
  }

  const handleCloseClick = () => {
    setConfirmed(false)
    setOpenDialog(false)
  }

  const onSuccess = async () => {
    setOpenDialog(false)
    notify('Feedback Updated', 'info')
  }

  const onFailure = async (error) => {
    setOpenDialog(false)
    notify(`An Error occured ${error.message}`, 'error')
  }

  const handleSave = async () => {
    setConfirmed(true)
  }

  const handleSubmit = async (values) => {
    update('visits', record.id, values, null, { onSuccess, onFailure })
  }

  return (
    <>
      <Button
        {...props}
        onClick={handleOnclick}
        label="feedback"
        startIcon={<RateReviewIcon />}
        disabled={feedbackButtonDisabled}
      />
      <Dialog open={openDialog}>
        <DialogTitle id="alert-dialog-title">{'Visit Feedback'}</DialogTitle>
        <Edit {...props} resource="visits" id={props.record.id}>
          <FormWithRedirect
            resource="visits"
            save={handleSubmit}
            redirect={false}
            render={({ handleSubmit }) => (
              <>
                <DialogContent>
                  {confirmed && (
                    <Box mb={2}>
                      <Alert severity="warning" mb={2}>
                        <AlertTitle>Warning</AlertTitle>
                        You can enter feedback only once. <br /> Are you sure? — Click <strong>confirm</strong> to continue,
                        cancel otherwise
                      </Alert>
                    </Box>
                  )}
                  <StyledInput component={SelectInput} choices={outcomeChoices} validate={[required()]} source="outcome" />
                  <StyledInput component={TextInput} multiline={true} validate={[required()]} source="comment" />
                </DialogContent>
                <DialogActions>
                  <Button label="Cancel" onClick={handleCloseClick} startIcon={<CancelIcon />} />
                  {!confirmed && <Button onClick={handleSave} label="save" />}
                  {confirmed && <SaveButton handleSubmitWithRedirect={handleSubmit} saving={loading} label="confirm" />}
                </DialogActions>
              </>
            )}
          />
        </Edit>
      </Dialog>
    </>
  )
}

export default VisitFeedbackButton
